var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVectorGraphics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    viewBox: "0 0 150 150",
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.449219 6.578125 L 142.449219 6.578125 L 142.449219 143.078125 L 7.449219 143.078125 Z M 7.449219 6.578125"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.496094 6.574219 L 131.449219 6.574219 L 134.738281 40.898438 L 130.105469 40.898438 C 129.539062 34.121094 128.15625 28.953125 125.964844 25.398438 C 123.769531 21.839844 120.761719 19.222656 116.945312 17.546875 C 113.125 15.867188 107.070312 15.0625 98.785156 15.128906 L 42.351562 15.128906 L 92.6875 68.480469 L 35.40625 124.351562 L 98.175781 124.351562 C 109.550781 124.351562 118.246094 122.839844 124.257812 119.820312 C 130.269531 116.800781 134.777344 110.492188 137.785156 100.894531 L 142.417969 101.800781 L 135.347656 143.074219 L 7.496094 143.074219 L 7.496094 139.449219 L 71.117188 77.441406 L 7.496094 10.195312 Z M 7.496094 6.574219"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVectorGraphics);
export default __webpack_public_path__ + "static/media/Logo-Vector-Graphics.c38117265a17f6381b400d0cb9af8a4f.svg";
export { ForwardRef as ReactComponent };